import React from "react";
import Controlling from "../Controlling";

const ControllingWidget = ({ employees }) => (
  <div className="widget-content-scroll">
    <Controlling employees={employees || []} readOnly={true} />
  </div>
);

export default ControllingWidget;
